import { render } from "./CustomerReviewCard.vue?vue&type=template&id=bd1e03a6"
import script from "./CustomerReviewCard.vue?vue&type=script&lang=js"
export * from "./CustomerReviewCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__